<template>
  <div>
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">

      <template slot="button" slot-scope="params">
        <el-button class="dispatchbtn" type="danger" @click="settleConfirm(params.params)" size="mini">审核</el-button>
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'contract',
      formInline: {
        isstatus: 3,
      },
      formCtrl: [
        {
          label: "合同编号",
          keyName: "con_num",
          placeholder: "请填写合同编号",
          type: "text",
        },
        {
          label: "客户名称",
          keyName: "shname",
          placeholder: "请填写客户名称",
          type: "text",
        },
      ],
      cols: [
        { keyName: "con_num", label: "合同编号", minwidth: 120 },
        { keyName: "shname", label: "客户名称", minwidth: 130 },
        { keyName: "name", label: "货物名称", minwidth: 110 },
        { keyName: "pricing", label: "计价方式", minwidth: 120 },
        { keyName: "cprice", label: "公司单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "dprice", label: "司机单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "ton", label: "合同量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "inton", label: "装货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "unton", label: "卸货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "caton", label: "计算量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "starttime", label: "开始日期", minwidth: 120 },
        { keyName: "endtime", label: "结束日期", minwidth: 120 },
        { keyName: "coaddress", label: "装货地址", minwidth: 120 },
        { keyName: "enaddress", label: "卸货地址", minwidth: 120 },
      ],
      allBtnWidth: 128,
      btns: [
        {
          icon: 'el-icon-paperclip',
          class: 'fjbtn',
          title: '附件',
          cb: ({ id }) => {
            let mode = 'view'
            const { user_group_id } = this.user
            if ([2, 3, 4].includes(user_group_id)) {
              mode = 'edit'
            }
            this.$router.push(
              `/contract/file?id=${id}&mode=${mode}`
            );
          },
        },
        {
          title: '合同统计',
          img: require('@/assets/img/icon_count.png'),
          unimg: require('@/assets/img/icon_count_hover.png'),
          cb: ({ id }) => {
            this.$router.push(
              `/contract/statistics?id=${id}`
            );
          },
        },
        {
          title: '运单列表',
          //icon: 'el-icon-s-order',
          img: require('@/assets/img/icon_order.png'),
          unimg: require('@/assets/img/icon_order_hover.png'),
          cb: ({ id }) => {
            this.$router.push(
              `/contract/orderlist?id=${id}`
            );
          },
        },
        {
          ...this.viewBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/contract/detail?id=${id}&mode=view`
            );
          },
        },
      ],
      baseParams: ['isstatus'],
    };
  },
  methods: {
    settleConfirm({ id }) {
      this.$confirm('审核通过后不可撤销，是否通过?', '审核通过', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.checkReq(id);
      }).catch(() => { });
    },
    checkReq(id) {
      this.loading = true
      let url = `${this.baseUrl}/updateisstatus`;
      const params = {
        userid: this.user.id,
        id,
      }
      this.post(url, params, ({ msg }) => {
        this.loading = false
        if (msg == 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '出错了！'
        });
      })
    },
  },
  created() {
    const { user_group_id } = this.user
    if ([2, 3, 4].includes(user_group_id)) {
      this.cols.push({ keyName: '', label: '审核', slot: 'button', minwidth: 120 })
      this.btns[3] = {
        ...this.editBtn,
        cb: ({ id }) => {
          this.$router.push(
            `/contract/detail?id=${id}&mode=edit`
          );
        },
      }
    }
  },
  mounted() {
    this.getList()
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-table .pr30 .cell {
  padding-right: 30px;
}
</style>
